import {
  AfterContentInit,
  Component,
  ContentChildren,
  inject,
  Injectable,
  QueryList,
  TemplateRef,
  ChangeDetectionStrategy,
  input,
  output
} from '@angular/core'
import { Router } from '@angular/router'

import { RouterEventsService } from '@core/services/router-events/router-events.service'
import { TemplateDirective } from '@shared/directives/mcm-template.directive'
import { HeaderCollapseDirective } from '@shared/directives/mcm-header-collapse.directive'
import { LoaderComponent } from '../loader/loader.component'
import { NgClass, NgTemplateOutlet } from '@angular/common'
import { ButtonComponent } from '../button/button.component'
import { TranslatePipe } from '@ngx-translate/core'
import { IonButtons, IonHeader, IonToolbar } from '@ionic/angular/standalone'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoaderComponent,
    NgClass,
    NgTemplateOutlet,
    ButtonComponent,
    TranslatePipe,
    IonHeader,
    IonToolbar,
    IonButtons
  ]
})
@Injectable({
  providedIn: 'root'
})
export class HeaderComponent implements AfterContentInit {
  private readonly _collapseDirective = inject(HeaderCollapseDirective, { optional: true, self: true })
  private _router = inject(Router)
  public routerEventsService = inject(RouterEventsService)

  readonly title = input<string>(undefined)
  readonly loading = input(false)
  readonly showToolbar = input(true)
  readonly showBackButton = input(true)
  readonly disableNavigateBack = input(false)
  readonly extraClasses = input<string>(undefined)
  readonly titleParams = input<{
    [key: string]: string
  }>(undefined)
  readonly navigateBackUrl = input<string>(undefined)

  @ContentChildren(TemplateDirective) templates: QueryList<TemplateDirective>

  readonly navigationBack = output()

  titleTemplate: TemplateRef<any>
  startButtonsTemplate: TemplateRef<any>
  endButtonsTemplate: TemplateRef<any>
  contentTemplate: TemplateRef<any>

  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngAfterContentInit() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'title':
          this.titleTemplate = item.template
          break
        case 'start-buttons':
          this.startButtonsTemplate = item.template
          break
        case 'end-buttons':
          this.endButtonsTemplate = item.template
          break
        case 'content':
          this.contentTemplate = item.template
          break
      }
    })
  }

  expand() {
    this._collapseDirective?.expand()
  }

  collapse() {
    this._collapseDirective.collapse()
  }

  isCollapsed() {
    return this._collapseDirective?.isCollapsed
  }

  onBackNavigation() {
    this.navigationBack.emit()
    const navigateBackUrl = this.navigateBackUrl()
    if (navigateBackUrl) {
      void this._router.navigate([navigateBackUrl])
    } else {
      this.routerEventsService.goBack()
    }
  }
}
